import { useEffect, useRef, useState } from "react";
import { useDeviceList } from "./provider/DeviceListProvider";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../components/Spinner/Spinner";
import Space from "./Space";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import NormalButton from "../components/Button/NormalButton";
import { useTheme } from "../context/ThemeContext";
function ProxView() {
  const { deviceList, loading: deviceListLoading } = useDeviceList();
  const [device, setDevice] = useState(null);
  const { deviceId } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [url, setUrl] = useState(null);
  const [deviceName, setDeviceName] = useState(null);
  const [loadTimeout, setLoadTimeout] = useState(false);
  const [urls, setUrls] = useState([]);

  useEffect(() => {
    console.log("device id: " + deviceId);
    if (deviceListLoading) {
      setLoading(true);
      return;
    }
    const newDevice = deviceList.find((device) => {
      return device.deviceId === deviceId;
    });
    console.log("newDevice:");
    console.log(newDevice);
    if (newDevice != null) {
      setDevice((prev) => {
        return newDevice;
      });
      setDeviceName((prev) => {
        if (prev === newDevice.name) {
          return prev;
        } else {
          return newDevice.name;
        }
      });
      setError(null);
      setUrls((prev) => {
        return newDevice.connectionAddress.map((address) => {
          return address.connectUrl;
        });
      });
    } else {
      setUrls([]);
      setLoading(false);
      setError("手机不在线，请检查文件闪传是否打开");
    }
  }, [deviceId, deviceList, deviceListLoading]);

  useEffect(() => {
    if (deviceName) {
      document.title = `${deviceName} - 文件闪传`;
    }
  }, [deviceName]);

  useEffect(() => {
    async function checkUrls(urls) {
      for (const url of urls) {
        try {
          console.log("testing " + url.pingUrl);
          const response = await fetch(url.pingUrl, { method: "HEAD" });
          if (response.ok) {
            console.log("连接成功: " + url.pingUrl);
            return url;
          }
        } catch (error) {
          console.error(error);
          console.log("访问失败: " + url.pingUrl);
        }
      }
      console.log("所有地址都无法访问");
      return null;
    }
    if (device != null) {
      setLoading(true);
      checkUrls(device.connectionAddress).then((result) => {
        if (result) {
          setError(null);
          setUrl(result.connectUrl);
        } else {
          // 地址没法访问，可能是因为Chrome的PNA访问限制， 尝试用第一个ip地址打开iframe
          if (device.connectionAddress.length > 0) {
            setUrl(device.connectionAddress[0].connectUrl);
          } else {
            setUrl(null);
            setError(`地址无法连接，请尝试手动打开地址`);
          }
          // setUrl(null);
          // setError(`地址无法连接，请尝试手动打开地址`);
        }
        setLoading(false);
      });
    }
  }, [device]);

  useEffect(() => {
    setLoadTimeout(false);
  }, [url]);

  const handleLoadTimeout = () => {
    console.log("handleLoadTimeout");
    setLoadTimeout(true);
  };

  return (
    <div className="w-full h-full relative">
      {loading && <LoadingContent />}
      {url != null && <RemoteContent key={url} url={url} onTimeout={handleLoadTimeout} />}
      {!loading && error != null && url == null && <ErrorContent error={error} urls={urls} />}
      {loadTimeout && <LoadTimeoutContent url={url} />}
    </div>
  );
}

function LoadTimeoutContent({ url }) {
  const useHttps = url.startsWith("https");
  useEffect(() => {
    if (!useHttps) {
      window.location.href = url;
    }
  }, [useHttps, url]);
  return (
    <div className="flex absolute left-0 top-0 w-full h-full items-center justify-center">
      <div className="flex flex-col items-center justify-start">
        <ErrorContent
          error={"加载页面超时"}
          desc={useHttps ? "请点击下面的URL，在新的页面进行操作，然后返回此页面进行刷新" : null}
          urls={[url]}
        />
        {useHttps && <img src="/https_connect_tips.svg" alt="connect_https_tips" />}
      </div>
    </div>
  );
}

function ErrorContent({ error, desc, urls }) {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center">
      <Space height="20px" />
      <div className="bg-[var(--photos-var-fill)] rounded-[16px] shadow-[0_11px_34px_var(--shadow-color)]">
        <div className="w-[300px] md:w-[400px] px-[18px] py-[20px] flex flex-col items-start gap-[18px]">
          <FontAwesomeIcon icon={faTriangleExclamation} className="text-4xl text-warning" />
          <div className="flex flex-col items-start gap-[8px]">
            <div className="text-[20px] text-primary">{error}</div>
            {desc && <div className="text-[14px]">{desc}</div>}
          </div>
          {urls && (
            <>
              {urls.map((url) => {
                return (
                  <a key={url} href={url} target="_blank" className="text-[14px]">
                    {url}
                    <FontAwesomeIcon icon={faExternalLink} className="pl-[4px]" />
                  </a>
                );
              })}
            </>
          )}
          <div className="flex flex-row items-start justify-center gap-[12px]">
            <NormalButton
              text={"刷新"}
              onClick={() => {
                window.location.reload();
              }}
            />
            <NormalButton
              text={"返回首页"}
              onClick={() => {
                navigate("/");
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function LoadingContent() {
  return (
    <div className="flex w-full h-full items-center justify-center absolute top-0 left-0 bg-fillTransparent">
      <Spinner />
    </div>
  );
}

function RemoteContent({ url, onTimeout }) {
  var ref = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const { theme, setTheme } = useTheme();

  useEffect(() => {
    var timeoutHandle = setTimeout(() => {
      console.log("open iframe timeout.");
      onTimeout && onTimeout();
    }, 4000);

    var sendPingHandle;
    const messageListener = (event) => {
      console.log("parent receive message: ");
      console.log(event.data);
      console.log("parent receive message origin");
      console.log(event.origin);
      if (event.data === "pong") {
        console.log("it's good.");
        clearTimeout(timeoutHandle);
        clearInterval(sendPingHandle);
      } else if (event.data.type && event.data.type === "changeTheme") {
        console.log("change theme.");
        setTheme(event.data.theme);
      }
      console.log("message: " + event.data);
    };
    window.addEventListener("message", messageListener);

    if (ref.current != null && loaded) {
      sendPingHandle = setInterval(() => {
        console.log("postMessage ping to " + url);
        ref.current.contentWindow.postMessage("ping", url);
      }, 1000);
    }

    return () => {
      if (sendPingHandle) {
        clearInterval(sendPingHandle);
      }
      clearTimeout(timeoutHandle);
      window.removeEventListener("message", messageListener);
    };
  }, [loaded]);

  return (
    <iframe
      ref={ref}
      className="w-full h-full absolute left-0 top-0"
      src={url}
      title={url}
      onError={() => {
        console.log("iframe error!!!");
      }}
      onLoad={(e) => {
        console.log("iframe onload");
        setLoaded(true);
      }}
    />
  );
}

export default ProxView;
